import { render } from "./My.vue?vue&type=template&id=3919fede&scoped=true"
import script from "./My.vue?vue&type=script&lang=js"
export * from "./My.vue?vue&type=script&lang=js"

import "./My.vue?vue&type=style&index=0&id=3919fede&lang=less&scoped=true"

import exportComponent from "/data/web/antpay-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3919fede"]])

export default __exports__